<template>
  <aside class="card_aside" v-if="!isShow" style="margin-right: 22px;">
    <div class="aside_info">
      <!-- style="margin-top:26px;" -->
      <a-avatar :size="54" :src="(userData.headImgUrl || defaultAvatar)" />
      <div class="fontTitle">{{ userData.nickName }}</div>
      <p class="oName">{{ copywriting }}</p>
    </div>
    <div class="aside_data">
      <div class="data_item">
        <div class="fontText">{{ studyInfo.learningTime || 0 }}h</div>
        <p class="font-12 color">学习时长</p>
      </div>
      <div class="data_item">
        <div class="fontText">{{ studyInfo.homeWorkNum || 0 }}</div>
        <p class="font-12 color">我的作业</p>
      </div>
      <div class="data_item">
        <div class="fontText">{{ studyInfo.themeNum || 0 }}</div>
        <p class="font-12 color">我的问答</p>
      </div>
    </div>
    <div class="aside_live_broadcast" @click="toLiveCalendar">
      <div class="calendar pl-3">
        <svg-icon class="font-22 mr-2" iconClass="calendar"></svg-icon>
        <span style="color:#303133;font-size: 14px;">直播日历</span>
      </div>
      <h3 class="course">
        <span v-if="studyInfo.liveNum > 0">今日{{ studyInfo.liveNum }}节直播课</span>
        <span v-else>当日暂无直播课</span>
      </h3>
    </div>
    <div class="aside_list">
      <router-link class="list_item" v-for="(item, index) in menus" :key="index"
        :to="{ name: item.name, query: { ocode: ocode } }">
        <svg-icon class="font-22 mr-2" :iconClass="routeName(item)"></svg-icon>
        <span>{{ item.title }}</span>
      </router-link>
    </div>
  </aside>
</template>
<script>
import { randomText } from '@/utils/util'
import Vue from 'vue'
const defaultAvatar = require('@/assets/defaultAvatar.png')

export default {
  name: '',
  props: {
    studyInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      // rili,
      // bofang,
      defaultAvatar,
      menus: [
        {
          title: '我的课程',
          icon: 'fund',
          name: 'course',
          default: 'classDefault',
          actvie: 'classActive'
        },
        {
          title: '我的问答',
          icon: 'fund',
          name: 'qa',
          default: 'qaDefault',
          actvie: 'qaActive'
        },
        {
          title: '课程码激活',
          icon: 'fund',
          name: 'activate',
          default: 'codeDefault',
          actvie: 'codeActive'
        },
        {
          title: '账号管理',
          icon: 'fund',
          name: 'account',
          default: 'accountDefault',
          actvie: 'accountActive'
        }
      ],
     // ocode: Vue.ls.get('code'),
    }
  },
  computed: {

    userData() {
      return this.$store.getters.getUserData(['nickName', 'headImgUrl', 'phoneNumber'])
    },
    isShow() {
      return ['gradeDetail', 'myClassDetail', 'qadetails', 'liveCalendar'].includes(this.$route.name)
    },
    copywriting() {
      return this.randomText()
    },
    routeName() {
      return function (data) {
        return data.name === this.$route.name ? data.actvie : data.default
      }
    },
    ocode() {
      return Vue.ls.get('code')
    },
  },
  methods: {
    randomText,
    toLiveCalendar() {
      this.$router.push({ name: 'liveCalendar', query: { ocode: Vue.ls.get('code') } })
    },
  }
}
</script>
<style lang="less" scoped>
@font-color: #303133;

.card_aside {
  width: 304px;
  height: 640px;
  padding: 22px;
  // border-right: 1px solid #ced3dc;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(238, 239, 243, 0.5);

  .aside_info {
    display: flex;
    flex-direction: column;
    align-items: center;

    h5 {
      margin: 12px 0;
      font-size: 16px;
      font-weight: bold;
    }

    p {
      font-size: 12px;
    }
  }

  .aside_data {
    display: flex;
    justify-content: space-between;

    .data_item {
      margin: 24px 4px;
      text-align: center;

      h5 {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
      }

      p {
        font-size: 12px;
      }
    }
  }

  .aside_live_broadcast {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 6px;
    padding-bottom: 22px;
    border-bottom: 1px solid #ced3dc;
    cursor: pointer;

    h3 {
      height: 100%;
      line-height: 100%;
      font-size: 16px;
    }

    .course {
      // margin-left: 14px;
      padding: 0 20px;
      height: 26px;
      line-height: 28px;
      color: #4B7DFD;
      background: #EBF2FF;
      border-radius: 10px;
      font-size: 12px;
      border-radius: 13px;
      margin-bottom: 0;
    }
  }

  .aside_list {
    padding-top: 20px;

    .list_item {
      // display: block;
      display: flex;
      align-items: center;
      padding: 0 15px;
      margin-bottom: 4px;
      height: 40px;
      line-height: 40px;
      color: #303133;
      cursor: pointer;
    }

    .list_item:hover {
      background: #F2F6FF;
    }

    .router-link-active {
      color: #4B7DFD;
      background: #F2F6FF;
      border-radius: 4px;
    }
  }
}

.fontText {
  color: @font-color;
  font-size: 24px;
  font-weight: bold;
}

.fontTitle {
  color: @font-color;
  font-size: 16px;
  margin: 14px 0;
  font-weight: 600;
}

.oName {
  color: #84878d;
  font-size: 12px;
  font-weight: 500;
}

.color {
  color: @font-color;
}

.calendar {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
